// import { Container, Grid } from "@mui/material";
// import { useState } from "react";
// import { useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import TopBar from "../../../components/TopBar/TopBar";
// import AppointmentApprove from "./AppointmentApprove";
// import NewCalendar from "./NewCalendar";

// const Appointments = () => {
//   const location = useLocation();
//   const [selectedTab, setSelectedTab] = useState(
//     location?.state?.selectedTab ?? "calendar"
//   );
//   const appointemntApproveList = useSelector(
//     (state) => state?.clinic?.appointmentList
//   );

//   return (
//     <>
//       <TopBar>
//         <Container maxWidth="xl">
//           <Grid container spacing={0} className="flex-center">
//             <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
//               <Grid container spacing={0}>
//                 <div className="flex-row">
//                   <div
//                     className="ph10pv3"
//                     onClick={() => setSelectedTab("calendar")}
//                   >
//                     <div
//                       className={`flex-center cursor ${
//                         selectedTab === "calendar"
//                           ? "pet-det-sel-tab"
//                           : "pet-det-un-sel-tab"
//                       }`}
//                     >
//                       Calendar
//                     </div>
//                   </div>
//                   <div
//                     className="ph10pv3"
//                     onClick={() => setSelectedTab("requests")}
//                   >
//                     <div
//                       className={`flex-center cursor ${
//                         selectedTab === "requests"
//                           ? "pet-det-sel-tab"
//                           : "pet-det-un-sel-tab"
//                       }`}
//                     >
//                       Requests
//                       {appointemntApproveList?.length > 0 && (
//                         <div className="red-dot request-btn-dot-pos" />
//                       )}
//                     </div>
//                   </div>
//                                     <div
//                     className="ph10pv3"
//                     onClick={() => setSelectedTab("dashboard")}
//                   >
//                     <div
//                       className={`flex-center cursor ${
//                         selectedTab === "dashboard"
//                           ? "pet-det-sel-tab"
//                           : "pet-det-un-sel-tab"
//                       }`}
//                     >
//                       Dashboard
//                     </div>
//                   </div>

//                 </div>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Container>
//       </TopBar>
//       {selectedTab === "calendar" ? <NewCalendar /> : <AppointmentApprove />}
//     </>
//   );
// };

// export default Appointments;
// import { Container, Grid } from "@mui/material";
// import { useState } from "react";
// import { useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import TopBar from "../../../components/TopBar/TopBar";
// import AppointmentApprove from "./AppointmentApprove";
// import NewCalendar from "./NewCalendar";
// import App from "./Dashboards.js/App"; // Add import for App component

// const Appointments = () => {
//   const location = useLocation();
//   const [selectedTab, setSelectedTab] = useState(
//     location?.state?.selectedTab ?? "calendar"
//   );
//   const appointemntApproveList = useSelector(
//     (state) => state?.clinic?.appointmentList
//   );

//   // Function to render the selected component
//   const renderSelectedComponent = () => {
//     switch (selectedTab) {
//       case "calendar":
//         return <NewCalendar />;
//       case "requests":
//         return <AppointmentApprove />;
//       case "dashboard":
//         return <App />;
//       default:
//         return <NewCalendar />;
//     }
//   };

//   return (
//     <>
//       <TopBar>
//         <Container maxWidth="xl">
//           <Grid container spacing={0} className="flex-center">
//             <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
//               <Grid container spacing={0}>
//                 <div className="flex-row">
//                   <div
//                     className="ph10pv3"
//                     onClick={() => setSelectedTab("calendar")}
//                   >
//                     <div
//                       className={`flex-center cursor ${
//                         selectedTab === "calendar"
//                           ? "pet-det-sel-tab"
//                           : "pet-det-un-sel-tab"
//                       }`}
//                     >
//                       Calendar
//                     </div>
//                   </div>
//                   <div
//                     className="ph10pv3"
//                     onClick={() => setSelectedTab("requests")}
//                   >
//                     <div
//                       className={`flex-center cursor ${
//                         selectedTab === "requests"
//                           ? "pet-det-sel-tab"
//                           : "pet-det-un-sel-tab"
//                       }`}
//                     >
//                       Requests
//                       {appointemntApproveList?.length > 0 && (
//                         <div className="red-dot request-btn-dot-pos" />
//                       )}
//                     </div>
//                   </div>

//                   <div
//                     className="ph10pv3"
//                     onClick={() => setSelectedTab("dashboard")}
//                   >
//                     <div
//                       className={`flex-center cursor ${
//                         selectedTab === "dashboard"
//                           ? "pet-det-sel-tab"
//                           : "pet-det-un-sel-tab"
//                       }`}
//                     >
//                       Dashboard
//                     </div>
//                   </div>
//                 </div>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Container>
//       </TopBar>
//       {renderSelectedComponent()}
//     </>
//   );
// };

// export default Appointments;
import { Container, Grid } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import TopBar from "../../../components/TopBar/TopBar";
import NewCalendar from "../../NewAppointment/NewCalendar/NewCalendar";
import "./Appointment.css";
import AppointmentApprove from "./AppointmentApprove";
import App from "./Dashboards.js/App"; // Add import for App component
import Facilities from "./Facilities";

export const APPOINTMENTS_TAB_PATHS = {
  calendar: "calendar",
  requests: "requests",
  dashboard: "dashboard",
  facilities: "facilities",
};

export const APPOINTMENTS_PATH_TO_TAB = {
  calendar: "calendar",
  requests: "requests",
  dashboard: "dashboard",
  facilities: "facilities",
};

export const AppointmentsRedirect = () => {
  const location = useLocation();
  const tabFromState = location.state?.selectedTab;
  const path =
    APPOINTMENTS_TAB_PATHS[tabFromState] ?? APPOINTMENTS_TAB_PATHS.calendar;
  return (
    <Navigate to={`/appointments/${path}`} replace state={location.state} />
  );
};

const Appointments = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { tab } = useParams();
  const selectedTab = APPOINTMENTS_PATH_TO_TAB[tab];
  const [subTab, setSubTab] = useState(null);
  const [facilityAnchorEl, setFacilityAnchorEl] = useState(null);
  const appointemntApproveList = useSelector(
    (state) => state?.clinic?.appointmentList,
  );

  // Function to render the selected component
  const renderSelectedComponent = () => {
    switch (selectedTab) {
      case "calendar":
        return <NewCalendar />;
      case "requests":
        return <AppointmentApprove />;
      case "facilities":
        return <Facilities />;
      case "dashboard":
        return (
          <div
            style={{
              height: "calc(100vh - 120px)", // Adjust height based on your TopBar height
              overflowY: "auto",
              overflowX: "hidden",
              padding: "0 8px",
              // Custom scrollbar styling
              scrollbarWidth: "thin",
              scrollbarColor: "#888 #f1f1f1",
            }}
            className="dashboard-scroll-container"
          >
            <App />
          </div>
        );
      default:
        return <NewCalendar />;
    }
  };

  const onChangeTab = (nextTab) => {
    if (!nextTab || nextTab === selectedTab) return;
    setSubTab(null);
    const path =
      APPOINTMENTS_TAB_PATHS[nextTab] ?? APPOINTMENTS_TAB_PATHS.calendar;
    navigate(`/appointments/${path}`, { state: location.state });
  };

  const handleChangeMaster = (val) => {
    setSubTab(val);
    navigate(`/appointments/${APPOINTMENTS_TAB_PATHS.facilities}`, {
      state: location.state,
    });
  };

  if (!selectedTab) {
    return (
      <Navigate
        to={`/appointments/${APPOINTMENTS_TAB_PATHS.calendar}`}
        replace
        state={location.state}
      />
    );
  }

  return (
    <>
      <TopBar sx={selectedTab === "requests" ? { pb: 1 } : undefined}>
        <Container maxWidth="xl">
          <Grid container spacing={0} className="flex-center">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid container spacing={0}>
                <div className="flex-row-ali-cen">
                  <div
                    className="ph10pv3"
                    onClick={() => onChangeTab("calendar")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "calendar"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Calendar
                    </div>
                  </div>
                  <div
                    className="ph10pv3"
                    onClick={() => onChangeTab("requests")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "requests"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Requests
                      {appointemntApproveList?.length > 0 && (
                        <div className="red-dot request-btn-dot-pos" />
                      )}
                    </div>
                  </div>

                  <div
                    className="ph10pv3"
                    onClick={() => onChangeTab("dashboard")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "dashboard"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Dashboard
                    </div>
                  </div>
                  {/* <div className="ml10" style={{ width: 200 }}>
                    <CustomSelect
                      hoverSelect
                      value={subTab}
                      handleChange={(e) => handleChangeMaster(e?.target?.value)}
                      label="Facilities"
                      list={[
                        "Consultation Room",
                        "Operation Theatre",
                        "Kennel",
                        "Devices",
                        "Bath Bays",
                      ]}
                    />
                  </div> */}
                  <div
                    className="ph10pv3"
                    onClick={() => onChangeTab("facilities")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "facilities"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Facilities
                    </div>
                  </div>
                  {/* <div className="w30Per">
                    <div
                      onMouseEnter={(e) => {
                        setFacilityAnchorEl(e.currentTarget);
                      }}
                      className={`flex-center cursor ${
                        selectedTab === "Facilities"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Facilities <ArrowDropDownIcon fontSize="small" />
                    </div>
                  </div>
                  <Menu
                    anchorEl={facilityAnchorEl}
                    open={Boolean(facilityAnchorEl)}
                    onClose={() => setFacilityAnchorEl(null)}
                    MenuListProps={{
                      onMouseLeave: () => setFacilityAnchorEl(null),
                    }}
                  >
                    <MenuItem
                      onClick={() => handleChangeMaster("Consultation Room")}
                    >
                      Consultation Room
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleChangeMaster("Operation Theatre")}
                    >
                      Operation Theatre
                    </MenuItem>
                    <MenuItem onClick={() => handleChangeMaster("Kennel")}>
                      Kennel
                    </MenuItem>
                    <MenuItem onClick={() => handleChangeMaster("Devices")}>
                      Devices
                    </MenuItem>
                    <MenuItem onClick={() => handleChangeMaster("Bath Bays")}>
                      Bath Bays
                    </MenuItem>
                  </Menu> */}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </TopBar>
      {renderSelectedComponent()}
    </>
  );
};

export default Appointments;
